import { buildUrl } from '../json-api/JsonApiUtils';

interface GetIdSetCriteria {
  endpoint: string;
  filters?: Record<string, string | Array<string>>;
  page?: number;
  pageSize?: number;
  query?: Record<string, { term: string; fields: Record<string, string> }>;
  entity: string;
  sortValue?: string;
  authToken?: string;
  extraFields?: string | null;
}

export const getIdSet = async ({
  endpoint,
  filters,
  page,
  pageSize,
  query,
  entity,
  sortValue,
  authToken,
  extraFields,
}: GetIdSetCriteria) => {
  const fields = extraFields ? `id,${extraFields}` : 'id';
  const url = buildUrl(endpoint, {
    filters,
    sorts: sortValue ? [{ value: sortValue }] : undefined,
    page: page === undefined ? undefined : { number: page, size: pageSize },
    query,
    fields: { [entity]: fields },
  });

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    ...(authToken && { Authorization: `Bearer ${authToken}` }),
  };

  const response = await fetch(url, {
    method: 'GET',
    headers,
    credentials: 'include',
  });

  return response.json();
};
